import axios from "axios";
import { BASE_URL } from "./api";


export async function getReportingRelationships(token, queryParams = "") {
    return axios({
        method: 'get',
        url: `${BASE_URL}/reporting-relationships/${queryParams}`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function createReportingRelationship(token, payload) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/reporting-relationships/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
        },
        data: payload,
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function deactivateReportingRelationship(token, id) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/reporting-relationships/${id}/deactivate/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}


export async function getUnassignedUsers(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/reporting-relationships/unassigned/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}